import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/orders/flagged')({
  staticData: {
    title: 'route.orders.flagged',
    crumb: 'route.orders.flagged',
    permissions: ['orders_flagged_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
